var _path, _circle, _line, _line2, _circle2, _line3, _circle3, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProsperoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 70,
    viewBox: "50 -10 600 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 10c-5 0-50 10-50 50v40c0 25 20 50 50 70 30-20 50-45 50-70V60c0-40-45-50-50-50z",
    fill: "#1D50D8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 85,
    r: 25,
    fill: "none",
    stroke: "#14B8A6",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 117,
    y1: 102,
    x2: 135,
    y2: 120,
    stroke: "#14B8A6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 65,
    x2: 70,
    y2: 45,
    stroke: "#14B8A6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 45,
    r: 4,
    fill: "#14B8A6"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 65,
    x2: 130,
    y2: 45,
    stroke: "#14B8A6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 45,
    r: 4,
    fill: "#14B8A6"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 120,
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 96,
    fill: "#1D50D8",
    letterSpacing: 1.2
  }, "\n    Prospero\n  ")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProsperoLogo);
export default __webpack_public_path__ + "static/media/prospero_logo.0922e31c5f4f2092b51855f627381bfa.svg";
export { ForwardRef as ReactComponent };